import { Checkbox } from "@mantine/core";

interface ChoiceButtonProps {
  checked: boolean;
  onClick: () => void;
  label: any;
  description?: string;
  className?: string;
  icon?: React.ReactNode;
  dataTestId?: string;
}

export const ChoiceButton: React.FC<ChoiceButtonProps> = ({
  checked,
  onClick,
  label,
  description,
  className,
  icon,
  dataTestId,
}) => (
  <div
    data-testid={dataTestId}
    role="button"
    tabIndex={0}
    aria-pressed={checked} // Optional, if the div acts like a toggle button
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        onClick();
      }
    }}
    className={`${className ?? "choice-btn"}  ${checked ? "checked" : ""}`}
  >
    <Checkbox checked={checked} readOnly radius="xl" size="md" />
    <div>
      <div className="icon-wrapper">
        {icon}
        <span className="option-text">{label}</span>
      </div>

      {description && <p>{description}</p>}
    </div>
  </div>
);
